import {Injectable}                                                       from '@angular/core';
import {CaffConfIntf, CaffRecordLogIntf, CaffRecordSumIntf, CrudPathDict} from '@djsharkk/logr-types';
import {BehaviorSubject, Subscription}                                    from 'rxjs';
import {DataFirebaseBase}                                                 from './data-firebase.base';

@Injectable({
				providedIn: 'root'
			})
export class DataCaffService extends DataFirebaseBase<CaffRecordLogIntf, CaffRecordSumIntf> {
	protected paths: CrudPathDict = {
		log: 'caff_records_log',
		sum: 'caff_records_sum'
	};


	caffConfsSub: Subscription;
	caffConfs = new BehaviorSubject<CaffConfIntf[]>([])


	constructor() {
		super();
		this.caffConfsSub = this.svcFirebaseTools.recFetch<CaffConfIntf>('caff_conf').subscribe(records => {
			this.caffConfs.next(records)
		})
	}


}
